import { useAtomValue } from "jotai";
import { type FunctionComponent } from "react";

import { BaseLink } from "shared/components/common/base-link";
import { config } from "shared/data";
import { accountAtom } from "shared/lib/account/atoms";

import { useLoginDialogStateHelper } from "scmp-app/components/login-dialog/hooks";
import { usePlusBlurbPopup } from "scmp-app/components/plus/blurb-popup/hooks";

import {
  AlreadySubscriberText,
  AlreadySubscriberWrapper,
  Container,
  CtaButton,
  Left,
  LoginButton,
  Right,
  ScmpPlusName,
} from "./styles";

type Props = {
  className?: string;
  ctaButtonOnClick?: () => void;
};

export const PlusBlurbMessage: FunctionComponent<Props> = ({ className, ctaButtonOnClick }) => {
  const { hasScmpPlusAccessRight, isSubscriber } = usePlusBlurbPopup();
  const { openLoginDialog } = useLoginDialogStateHelper();
  const { isLoggedIn } = useAtomValue(accountAtom);

  const handleLoginClick = () => {
    openLoginDialog({
      application: "scmp-plus",
      destination: window.location.href,
    });
  };

  const messageDetail =
    isLoggedIn && isSubscriber && !hasScmpPlusAccessRight
      ? {
          ctaLabel: "upgrade",
          ctaText: "upgrade",
          redirectUrl: `${config.account.scmpAccountHost}/manage/subscription?upgrade=true`,
        }
      : {
          ctaLabel: "try for free",
          ctaText: "subscribe",
          redirectUrl: `${config.rosetta.subscribeHost}/plus#sign-up-section`,
        };

  return (
    <Container className={className}>
      <Left>
        <ScmpPlusName>SCMP Plus</ScmpPlusName> is a premium news platform that gives you an
        all-inclusive edge to stay ahead on China news. To access our exclusive content you’ll need
        to {messageDetail.ctaText}.
      </Left>
      <Right>
        <BaseLink onClick={ctaButtonOnClick} pathname={messageDetail.redirectUrl}>
          <CtaButton>{messageDetail.ctaLabel}</CtaButton>
        </BaseLink>
        {!isLoggedIn && (
          <AlreadySubscriberWrapper>
            <AlreadySubscriberText>Already a subscriber?</AlreadySubscriberText>
            <LoginButton onClick={handleLoginClick}>log in</LoginButton>
          </AlreadySubscriberWrapper>
        )}
      </Right>
    </Container>
  );
};

PlusBlurbMessage.displayName = "PlusBlurbMessage";
